// extracted by mini-css-extract-plugin
export var bodySections = "_du-8";
export var gray = "_du-7";
export var green = "_du-4";
export var iconContainer = "_du-9";
export var iconWidgetContainer = "_du-1";
export var phoneIcon = "_du-2";
export var red = "_du-5";
export var statusDot = "_du-3";
export var widgetContainer = "_du-0";
export var yellow = "_du-6";